import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { customTheme } from "../customTheme";
import { Button, Typography } from "@material-ui/core";
import moment from "moment";

const buttonStyle = {
	padding: 0,
	lineHeight: 1.5,
	color: customTheme.palette.primary.contrastText + "b",
	minWidth: 0,
};
const useStyles = makeStyles({
	root: {
		backgroundColor: customTheme.palette.primary.main,
		padding: "17px 17px",
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		color: customTheme.palette.primary.contrastText + "b",
	},
	dateContainer: {
		display: "grid",
		justifyItems: "flex-start",
	},
	year: {
		...buttonStyle,
		fontSize: 16,
	},
	month: {
		...buttonStyle,
		fontSize: 23,
	},
	time: {
		...buttonStyle,
		fontSize: 28,
	},
	ampmContainer: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
	},
	ampm: {
		...buttonStyle,
		fontSize: 13,
	},
});

export default function DateTimePickerToolbar({ date, openView, setOpenView, onChange }) {
	const classes = useStyles();
	const momentDateTime = moment(date);
	
	const changeToPM = () => {
		momentDateTime.add(12, 'h');
		onChange(momentDateTime.toDate());
	}
	
	const changeToAM = () => {
		momentDateTime.subtract(12, 'h');
		onChange(momentDateTime.toDate());
	}
	
	return (
		<div className={classes.root}>
			<div className={classes.dateContainer}>
				<Button className={classes.year} onClick={() => setOpenView("year")} style={openView === "year" ? { color: "#fff" } : {}}>{momentDateTime.format("YYYY")}</Button>
				<Button className={classes.month} onClick={() => setOpenView("date")} style={openView === "date" ? { color: "#fff" } : {}}>{momentDateTime.format("MMM DD")}</Button>
			</div>
			<div className={classes.timeContainer}>
				<Button className={classes.time} onClick={() => setOpenView("hours")} style={openView === "hours" ? { color: "#fff" } : {}}>{momentDateTime.format("hh")}</Button>
				<Typography component="span" style={{ position: "relative", top: 4, fontSize: 28, margin: "0 2px" }}>:</Typography>
				<Button className={classes.time} onClick={() => setOpenView("minutes")} style={openView === "minutes" ? { color: "#fff" } : {}}>{momentDateTime.format("mm")}</Button>
				<div className={classes.ampmContainer}>
					<Button className={classes.ampm} onClick={changeToAM} disabled={momentDateTime.format("A") === "AM"} style={momentDateTime.format("A") === "AM" ? { color: "#fff" } : {}}>AM</Button>
					<Button className={classes.ampm} onClick={changeToPM} disabled={momentDateTime.format("A") === "PM"} style={momentDateTime.format("A") === "PM" ? { color: "#fff" } : {}}>PM</Button>
				</div>
			</div>
		</div>
	);
}